import { useEffect, useState } from "react";

/** プレビューPaneを表示する最小画面幅 (Tailwind の lg) */
const PREVIEW_MIN_WIDTH = 1024;

/**
 * メール詳細プレビューPaneを表示できる画面幅か (lg 以上) を返す。
 * 狭い画面ではプレビューを出さず、クリック時は全画面遷移にフォールバックさせる。
 * @return {boolean} プレビュー表示可能なら true
 */
export function useCanShowPreview(): boolean {
  const [canShow, setCanShow] = useState<boolean>(
    () =>
      typeof window !== "undefined" && window.innerWidth >= PREVIEW_MIN_WIDTH,
  );

  useEffect(() => {
    const mql = window.matchMedia(`(min-width: ${PREVIEW_MIN_WIDTH}px)`);
    const handleChange = (event: MediaQueryListEvent): void => {
      setCanShow(event.matches);
    };
    setCanShow(mql.matches);
    mql.addEventListener("change", handleChange);
    return () => {
      mql.removeEventListener("change", handleChange);
    };
  }, []);

  return canShow;
}
